$(document).ready(function() {

	var menuButton		= $('#nav-open-btn');
	var menuSpeed		= 200;
	var page			= $('.page');
	var body			= $('body');
	var menu  			= $('div.menu');
	var openClass		= 'open';

	menuButton.click(function(e) {
		e.preventDefault();

		var menuOpen	= body.hasClass(openClass);

		// check or menu is open
		if(!menuOpen) {
			// open menu
			body.animate({
				marginLeft: '-250px'
			}, menuSpeed);
			menu.animate({
				right: 0
			}, menuSpeed);
			body.addClass(openClass);
		} else {
			// close menu
			body.animate({
				marginLeft: 0
			}, menuSpeed);
			menu.animate({
				right: '-250px'
			}, menuSpeed);
			body.removeClass(openClass);
		}
	});

	// Check for window resize
	$(window).resize(function() {
		responsiveMenuNN();
	});

	responsiveMenuNN();

	function responsiveMenuNN() {
		// Get window width resize browser
		var windowWidth	=	$(window).width();

		// Check for browser template or mobile template
		if(windowWidth > 767) {
			body.removeClass(openClass);
			body.removeAttr('style');
			menu.removeAttr('style');
			$('#top-inner').removeAttr('style');
		}
	}

});